// Accents and case aside, for the search fields of the menus: « carrefour »
// finds « CARREFOUR MARKET LORRAIN », « helene » finds « Hélène ».
export const foldText = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
